import '../styles/components/contact.css'
import { updateMeta, injectJsonLd, clearJsonLd } from '../utils/seo.js'

export function renderContact(outlet) {
  clearJsonLd()
  updateMeta({
    title: 'Contact Airplaten | Belt Grinder Platen Questions & Bulk Orders',
    description: 'Contact Airplaten for questions about carbon fiber platens, belt grinder compatibility, bulk pricing, or custom orders. We respond within 1 business day.',
    canonicalPath: '/#/contact',
  })

  injectJsonLd({
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    'name': 'Contact Airplaten',
    'url': 'https://www.airplaten.com/#/contact',
    'mainEntity': {
      '@type': 'Organization',
      'name': 'Airplaten',
      'email': 'hello@airplaten.com',
      'url': 'https://www.airplaten.com'
    }
  }, 'contact')

  outlet.innerHTML = `
    <div class="contact-page">
      <div class="container">
        <div class="contact-grid">
          <!-- Info -->
          <div class="contact-info">
            <div class="section-eyebrow">Get in Touch</div>
            <h1 class="contact-title">Let's talk about your project</h1>
            <p class="contact-desc">
              Have a question about our products, bulk pricing, or custom orders? We respond to every inquiry within one business day.
            </p>
            <div class="contact-details">
              <div class="contact-detail-item">
                <div class="contact-detail-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.75">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75" />
                  </svg>
                </div>
                <div>
                  <div class="contact-detail-label">Email</div>
                  <div class="contact-detail-value">hello@airplaten.com</div>
                </div>
              </div>
              <div class="contact-detail-item">
                <div class="contact-detail-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.75">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                  </svg>
                </div>
                <div>
                  <div class="contact-detail-label">Response Time</div>
                  <div class="contact-detail-value">Within 1 business day</div>
                </div>
              </div>
              <div class="contact-detail-item">
                <div class="contact-detail-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.75">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 18.75a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h6m-9 0H3.375a1.125 1.125 0 0 1-1.125-1.125V14.25m17.25 4.5a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m3 0h1.125c.621 0 1.129-.504 1.09-1.124a17.902 17.902 0 0 0-3.213-9.193 2.056 2.056 0 0 0-1.58-.86H14.25M16.5 18.75h-2.25m0-11.177v-.958c0-.568-.422-1.048-.987-1.106a48.554 48.554 0 0 0-10.026 0 1.106 1.106 0 0 1-.987 1.106v7.635m12-6.677v6.677m0 4.5v-4.5m0 0h-12" />
                  </svg>
                </div>
                <div>
                  <div class="contact-detail-label">Bulk & Trade Orders</div>
                  <div class="contact-detail-value">Volume discounts available</div>
                </div>
              </div>
            </div>
          </div>

          <!-- Form -->
          <div class="contact-form-box">
            <form class="contact-form" id="contact-form" novalidate>
              <div class="contact-form-row">
                <div class="form-group">
                  <label class="form-label" for="contact-name">Name *</label>
                  <input
                    class="form-input"
                    type="text"
                    id="contact-name"
                    name="name"
                    placeholder="Your name"
                    autocomplete="name"
                    required
                  >
                  <span class="form-error" id="name-error"></span>
                </div>
                <div class="form-group">
                  <label class="form-label" for="contact-email">Email *</label>
                  <input
                    class="form-input"
                    type="email"
                    id="contact-email"
                    name="email"
                    placeholder="you@example.com"
                    autocomplete="email"
                    required
                  >
                  <span class="form-error" id="email-error"></span>
                </div>
              </div>
              <div class="form-group">
                <label class="form-label" for="contact-phone">Phone (optional)</label>
                <input
                  class="form-input"
                  type="tel"
                  id="contact-phone"
                  name="phone"
                  placeholder="+1 (555) 000-0000"
                  autocomplete="tel"
                >
              </div>
              <div class="form-group">
                <label class="form-label" for="contact-message">Message *</label>
                <textarea
                  class="form-textarea"
                  id="contact-message"
                  name="message"
                  placeholder="Tell us about your project, quantity needs, or any questions..."
                  rows="5"
                  required
                ></textarea>
                <span class="form-error" id="message-error"></span>
              </div>
              <button type="submit" class="btn btn-primary btn-lg" id="contact-submit" style="width:100%">
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  `

  document.getElementById('contact-form')?.addEventListener('submit', handleSubmit)
}

async function handleSubmit(e) {
  e.preventDefault()

  const form = e.target
  const submitBtn = document.getElementById('contact-submit')

  // Clear errors
  document.querySelectorAll('.form-error').forEach(el => el.textContent = '')

  // Collect values
  const name = form.name.value.trim()
  const email = form.email.value.trim()
  const phone = form.phone.value.trim()
  const message = form.message.value.trim()

  // Validate
  let valid = true

  if (!name) {
    document.getElementById('name-error').textContent = 'Name is required.'
    valid = false
  }
  if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
    document.getElementById('email-error').textContent = 'A valid email is required.'
    valid = false
  }
  if (!message) {
    document.getElementById('message-error').textContent = 'Message is required.'
    valid = false
  }

  if (!valid) return

  // Submit
  submitBtn.disabled = true
  submitBtn.innerHTML = '<span class="spinner" style="width:18px;height:18px;border-width:2px"></span> Sending…'

  try {
    const res = await fetch('/api/send-email', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ name, email, phone, message }),
    })

    if (!res.ok) {
      const err = await res.json().catch(() => ({}))
      throw new Error(err.error || 'Failed to send message')
    }

    // Show success
    const box = document.querySelector('.contact-form-box')
    if (box) {
      box.innerHTML = `
        <div class="contact-success">
          <div class="contact-success-icon">
            <svg width="32" height="32" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
            </svg>
          </div>
          <h2 class="contact-success-title">Message sent!</h2>
          <p class="contact-success-desc">Thanks for reaching out. We'll get back to you within one business day.</p>
        </div>
      `
    }
  } catch (err) {
    console.error('[contact] Submit failed:', err)
    submitBtn.disabled = false
    submitBtn.textContent = 'Send Message'
    document.getElementById('message-error').textContent = err.message || 'Something went wrong. Please try again.'
  }
}
